interface SelectFieldProps {
  label?: string;
  value?: string | string[];
  multi?: boolean;
  options?: { label: string; value: string }[];
}

const SelectField = ({ label, value, options = [] }: SelectFieldProps) => {
  const raw: string[] = !value
    ? []
    : Array.isArray(value)
    ? value
    : [value];

  // Resolve raw snake_case values to their human-readable labels
  const resolveLabel = (rawVal: string): string => {
    const match = options.find((o) => o.value === rawVal);
    return match ? match.label : rawVal;
  };

  const displayValues = raw.map(resolveLabel);

  return (
    <div className="flex w-full items-start justify-between gap-6 py-3">
      {/* Left: label */}
      <div className="min-w-0 flex-1">
        <div className="text-primary-700 dark:text-primary-200 font-sans text-base font-semibold leading-tight">
          {label}
        </div>
      </div>

      {/* Right: badge(s) */}
      <div className="flex shrink-0 flex-wrap justify-end gap-1.5">
        {displayValues.length > 0 ? (
          displayValues.map((val, i) => (
            <span
              key={i}
              className="inline-flex items-center rounded-full border border-primary-200/60 bg-primary-50 px-3 py-1 font-sans text-sm font-medium text-primary-800 dark:border-primary-700/50 dark:bg-primary-900/30 dark:text-primary-200"
            >
              {val}
            </span>
          ))
        ) : (
          <span className="inline-flex items-center rounded-full border border-content-200 dark:border-content-700 bg-content-50 dark:bg-content-800 px-3 py-1 font-sans text-sm text-content-400 dark:text-content-500">
            —
          </span>
        )}
      </div>
    </div>
  );
};

export default SelectField;
